import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import DatePicker from "react-datetime";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import CreatableSelect from "react-select/creatable";
import { Helmet } from "react-helmet";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { URLS } from "../urls";
import { addDeduction, deleteDeduction } from "./deductionAction";
import {
  applyTo,
  maturityPeriod,
  payTypes,
  duration,
  maturityTime,
  fetchActionsUtil,
  useCookie,
} from "../../utils";
import ModalLoader from "../ModalLoader";
import { SelectComponent } from "../SelectComponent";
import { SingleDatePicker } from "../SingleDatePicker";

function DeductionSettings(props) {
  const branch_id = useCookie("branch_id");
  const userId = useCookie("userId");
  const history = useHistory();
  const token = "dummy token";

  const [settingsName, setSettingsName] = useState("");
  const [btnText, setBtnText] = useState("Save Settings");
  const [deleteBtnText, setDeleteBtnText] = useState("Delete");
  const [newSettingsName, setNewSettingsName] = useState("");
  const [deductionSettings, setDeductionSettings] = useState({
    percentage: 0,
    enabled: false,
  });
  const [applySelected, setApplySelected] = useState("All");
  const [paymentType, setPaymentType] = useState("");
  const [paymentPeriod, setPaymentPeriod] = useState("All");
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [gradeEmployees, setGradeEmployees] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [selectedGradeEmployees, setSelectedGradeEmployees] = useState([]);
  const [defaultGradeEmployees, setDefaultGradeEmployees] = useState([]);
  const [getAllSets, setGetAllSets] = useState([]);
  const [selectSettings, setSelectSettings] = useState([]);
  const [settingsDefault, setSettingsDefault] = useState([]);
  const [durationType, setDurationType] = useState("All");
  const [yearMonth, setYearMonth] = useState("");
  const [numberYearMonth, setNumberYearMonth] = useState("");
  const [calculatePer, setCalculatePer] = useState("");
  const [customSettings, setCustomSettings] = useState([]);
  const [showDeduct, setShowDeduct] = useState({});
  const [groupName, setGroupName] = useState("");
  const [allGroupName, setAllGroupName] = useState([]);
  const [salaryRange, setSalaryRange] = useState({
    minRange: 0,
    maxRange: 0,
  });
  const [defaultSelected, setDefaultSelected] = useState([]);

  const fetchSalarySettings = useCallback(async () => {
    try {
      const grades = await fetchActionsUtil(
        `${URLS.backendsalarySetting}/get/${branch_id}`
      );

      const jobGrades = grades?.jobGrades?.[0] || {};
      const items = Object.keys(jobGrades)
        .filter((key) => jobGrades[key] > 0 && key !== "custom")
        .reduce((acc, key) => ({ ...acc, [key]: true }), {});
      setShowDeduct(items);

      const custom = Array.isArray(jobGrades.custom)
        ? jobGrades.custom.map(({ name }) => ({ name, status: false }))
        : [];
      setCustomSettings(custom);
    } catch (error) {
      console.log(error);
    }
  }, [branch_id]);

  const getSettings = useCallback(
    async (slug) => {
      if (slug === "add-new") return;
      setIsFetching(true);
      try {
        const { deductionSettings = {} } = await fetchActionsUtil(
          `${URLS.backendDeductionSettings}/${slug}?branch_id=${branch_id}`
        );

        setDeductionSettings(deductionSettings);

        // Set state only if values exist
        if (deductionSettings?.maturityPeriod) {
          const [num, unit] = deductionSettings.maturityPeriod.split(" ");
          setYearMonth(unit || "");
          setNumberYearMonth(num || "");
        }
        if (deductionSettings?.durationType)
          setDurationType(deductionSettings.durationType);
        if (deductionSettings?.calculatePer)
          setCalculatePer(deductionSettings.calculatePer);
        if (deductionSettings?.paymentType)
          setPaymentType(deductionSettings.paymentType);
        if (deductionSettings?.paymentPeriod)
          setPaymentPeriod(deductionSettings.paymentPeriod);
        if (deductionSettings?.dateRange)
          setDateRange({
            endDate: deductionSettings?.dateRange.endDate || "",
            startDate: deductionSettings?.dateRange.startDate || "",
          });
        if (deductionSettings?.name) {
          setNewSettingsName(deductionSettings.name);
          setSettingsName(deductionSettings.name);
        }
        if (deductionSettings?.DeductType)
          setApplySelected(deductionSettings.DeductType);
        if (deductionSettings?.selectedDeducts)
          setDefaultGradeEmployees(deductionSettings.selectedDeducts);
        if (deductionSettings?.allSettings)
          setSettingsDefault(deductionSettings.allSettings);
        if (deductionSettings?.groupName)
          setGroupName(deductionSettings.groupName);
        setSalaryRange({
          maxRange: deductionSettings?.maxRange || 0,
          minRange: deductionSettings?.minRange || 0,
        });
        if (
          Array.isArray(deductionSettings?.customSettings) &&
          deductionSettings.customSettings.length > 0
        ) {
          setCustomSettings(deductionSettings.customSettings);
        }
      } catch (err) {
        console.log(err);
        toast("Unable to get settings, please try again", { type: "error" });
      } finally {
        setIsFetching(false);
      }
    },
    [branch_id]
  );

  useEffect(() => {
    const slug = window.location.pathname.split("/")[3];
    const name = slug.replaceAll("-", " ");
    setSettingsName(name);
    setNewSettingsName(name !== "add new" ? name : "");
    getSettings(slug);

    const unListen = history.listen((location) => {
      if (!location.pathname.includes("deduction-settings")) return;
      resetState();
      const slug = window.location.pathname.split("/")[3];
      const name = slug?.replaceAll("-", " ");
      setSettingsName(name);
      getSettings(slug);
    });

    return () => unListen();
  }, [settingsName, history, getSettings]);

  useEffect(() => {
    const data = defaultGradeEmployees?.length
      ? gradeEmployees?.filter((d) =>
          defaultGradeEmployees?.find((e) => e === d.value)
        )
      : [];
    setDefaultSelected(data);
    setSelectedGradeEmployees(data);
  }, [gradeEmployees, defaultGradeEmployees]);

  const onSelectApplyTo = useCallback(async () => {
    setIsFetching(true);
    setGradeEmployees([]);
    setSelectedGradeEmployees([]);

    const config = {
      "Job Grade": {
        url: `${URLS.backendJobGrades}/get/${branch_id}`,
        mapFn: (d) => ({ label: d.name, value: d._id }),
        dataKey: "jobGrades",
      },
      Employees: {
        url: `${URLS.backendEmployees}/get/${branch_id}`,
        mapFn: (d) => ({
          label: `${d?.personalInfo?.name?.first || ""} ${
            d?.personalInfo?.name?.middle || ""
          } ${d?.personalInfo?.name?.last || ""}`,
          value: d.userId,
        }),
        dataKey: "employees",
      },
      Contract: {
        url: `${URLS.backendContracts}/get/${branch_id}`,
        mapFn: (d) => ({ label: d.contractName, value: d._id }),
        dataKey: "contracts",
      },
    };

    const conf = config[applySelected];
    if (!conf) {
      setIsFetching(false);
      return;
    }

    try {
      const result = await fetchActionsUtil(conf.url);
      const dataArr = result[conf.dataKey] || [];
      setGradeEmployees(dataArr.map(conf.mapFn));
    } catch (error) {
      console.log(error);
      toast("Unable to fetch data!", { type: "error" });
    } finally {
      setIsFetching(false);
    }
  }, [applySelected, branch_id]);

  useEffect(() => {
    onSelectApplyTo();
  }, [onSelectApplyTo]);

  useEffect(() => {
    let abort = false;
    async function fetchData() {
      setIsFetching(true);
      try {
        const result = await fetchActionsUtil(
          `${URLS.backendApp}/set-up?branch_id=${branch_id}`
        );

        if (abort) return;
        const {
          allowance = [],
          benefit = [],
          bonusSettings = [],
          deductionSettings = [],
        } = result;
        // Use flatMap for efficiency, filter and map in one pass
        const all = [allowance, benefit, bonusSettings, deductionSettings]
          .flat()
          .reduce((acc, el) => {
            if (el.name !== settingsName) {
              acc.push({
                label: el.name,
                value: { name: el.name, level: el.level, slug: el.slug },
              });
            }
            return acc;
          }, []);
        setGetAllSets(all);
      } catch (err) {
        console.log(err);
        if (!abort) {
          toast("Unable to fetch !!!", {
            type: "error",
          });
        }
      } finally {
        if (!abort) setIsFetching(false);
      }
    }
    fetchData();
    return () => {
      abort = true;
    };
  }, [settingsName, branch_id]);

  const getGroupNames = useCallback(async () => {
    try {
      const response = await fetchActionsUtil(
        `${URLS.backendDeductionSettings}/all-group`
      );
      const groups = (response.allowance || []).map((el) => ({
        label: el,
        value: el,
      }));
      setAllGroupName(groups);
    } catch (err) {
      toast("Unable to fetch group names", { type: "error" });
    }
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getGroupNames();
      fetchSalarySettings();
    }
    return () => {
      isMounted = false;
    };
  }, [settingsName, getGroupNames, fetchSalarySettings]);

  const resetState = () => {
    setSettingsName("");
    setBtnText("Save Settings");
    setDeleteBtnText("Delete");
    setNewSettingsName("");
    setDeductionSettings({ percentage: 0, enabled: false });
    setSelectedGradeEmployees([]);
    setIsFetching(false);
    setGradeEmployees([]);
    setApplySelected("All");
    setDefaultGradeEmployees([]);
    setGetAllSets([]);
    setSettingsDefault([]);
    setDurationType("All");
    setYearMonth("");
    setNumberYearMonth("");
    setCalculatePer("");
    setCustomSettings([]);
    setShowDeduct({});
    setGroupName("");
    setAllGroupName([]);
    setSalaryRange({ minRange: 0, maxRange: 0 });
    setPaymentType("");
    setPaymentPeriod("All");
    setDateRange({ startDate: "", endDate: "" });
  };

  const deleteSetting = async (slug) => {
    toggleModal();
    setDeleteBtnText("Please wait...");
    setIsFetching(true);
    try {
      await fetchActionsUtil(
        `${URLS.backendDeductionSettings}/delete/${slug}?branch_id=${branch_id}`,
        "DELETE",
        token
      );
      toast.success("Settings deleted");
      resetState();
      props.deleteDeduction(slug);
      props.history.push("add-new");
    } catch (err) {
      console.error(err);
      toast.error("Unable to delete settings, please try again");
    } finally {
      setIsFetching(false);
      setDeleteBtnText("Delete");
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      setBtnText("Please wait...");
      if (!newSettingsName?.trim()) return toast.error("Name can not be empty");
      if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(newSettingsName))
        return toast.error("Only Space is allowed in Name");
      if (+salaryRange.minRange > +salaryRange.maxRange)
        return toast.error("Max can not be bigger than Min");

      const selected = selectedGradeEmployees.length
        ? selectedGradeEmployees.map((d) => d.value)
        : defaultGradeEmployees;
      const allSettings = selectSettings.length
        ? selectSettings.map((d) => d.value)
        : [];
      const level =
        allSettings.length < 1
          ? 1
          : Math.max(...allSettings.map((el) => el.level)) + 1;

      const theDeductionSettings = {
        ...deductionSettings,
        ...salaryRange,
        createdBy: userId,
        DeductType: applySelected,
        selectedDeducts: selected,
        name: newSettingsName,
        branch_id,
        paymentType,
        paymentPeriod,
        dateRange,
        allSettings,
        level,
        maturityPeriod: `${numberYearMonth} ${yearMonth}`,
        durationType,
        calculatePer,
        customSettings,
        groupName,
      };
      const data = await fetchActionsUtil(
        `${URLS.backendDeductionSettings}/add`,
        "POST",
        token,
        {
          deductionSettings: theDeductionSettings,
          isNew: settingsName === "add new",
        }
      );
      toast.success("Settings saved");
      setDeductionSettings({ ...data.deductionSettings });
      props.addDeduction({ ...data.deductionSettings });
      props.history.push(`${data.deductionSettings.slug}`);
    } catch (err) {
      toast.error(err?.toString() || "Unable to submit, please try again");
    } finally {
      setBtnText("Save Settings");
    }
  };

  const filterByDateRange = (event, name) => {
    setDateRange({
      ...dateRange,
      [name]: moment(event).format("MM/YYYY"),
    });
  };

  const validationEndDate = (currentDate) => {
    return currentDate.isAfter(
      moment(dateRange?.startDate, "MM/YYYY").add(0, "months")
    );
  };

  const changeCustom = (name) => {
    setCustomSettings((prev) =>
      prev.map((el) => (el.name === name ? { ...el, status: !el.status } : el))
    );
  };

  const toggleModal = () => {
    window.$("#delete_employee").modal("toggle");
  };

  const DisplayPercentageInput = ({ name, settings }) => {
    return (
      <div className="col-md-4">
        <div
          className="form-check"
          style={{
            height: "44px",
            padding: "6px 0",
            display: "inline-block",
          }}
        >
          <input
            style={{ height: "30px", width: "30px" }}
            type="checkbox"
            checked={settings?.[name]}
            name={name}
            onChange={(e) =>
              setDeductionSettings((prev) => ({
                ...prev,
                [name]: !prev[name],
              }))
            }
          />
          <label
            style={{
              margin: "10px",
              verticalAlign: "bottom",
            }}
          >
            {name}
          </label>
        </div>
      </div>
    );
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}
            <div className="row">
              <div className="col-9 text-capitalize">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <Link to={`${URLS.dashboard}`}>Dashboard</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Deduction Settings</BreadcrumbItem>
                  <BreadcrumbItem active>{settingsName}</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <div className="col-3">
                <Link
                  to="/dashboard/deduction-settings/add-new"
                  className="btn btn-primary"
                >
                  <i
                    className="la la-plus mr-1"
                    style={{ fontSize: "14px", marginBottom: "3px" }}
                  ></i>
                  Add New
                </Link>
              </div>
              {/*<div className="col-sm-7 col-7 text-right m-b-30"></div>*/}
            </div>
            {/*<!-- /Page Title -->*/}
            {/*<!-- Content Starts -->*/}
            <div class="p-3">
              <form onSubmit={(e) => submitForm(e)} autoComplete={false}>
                <h2 className="text-capitalize h3">
                  {settingsName === "add new" && "Create New Deduction"}
                </h2>

                <div className="col-md-8 pl-0">
                  {["paye tax", "pension", "nsitf", "company pension"].includes(
                    settingsName
                  ) ? null : (
                    <div className="form-group">
                      <label>Group Name</label>
                      <CreatableSelect
                        isClearable
                        onChange={(selected) => {
                          setGroupName(selected?.value);
                        }}
                        options={allGroupName}
                        value={allGroupName?.find(
                          (el) => el.value === groupName
                        )}
                      />
                    </div>
                  )}

                  <div className="row">
                    {[
                      "paye tax",
                      "pension",
                      "nsitf",
                      "company pension",
                    ].includes(settingsName) ? null : (
                      <div className="form-group col-md-6">
                        <label>Name</label>
                        <input
                          required
                          className="form-control"
                          type="text"
                          value={newSettingsName}
                          name="newSettingsName"
                          onChange={(e) => setNewSettingsName(e.target.value)}
                        />
                      </div>
                    )}

                    <div className="col-md-4">
                      <label>Enable</label>
                      <div
                        className="onoffswitch ml-0"
                        onClick={(e) => {
                          setDeductionSettings({
                            ...deductionSettings,
                            enabled: !deductionSettings?.enabled,
                          });
                        }}
                      >
                        <input
                          type="checkbox"
                          name="onoffswitch"
                          className="onoffswitch-checkbox"
                          checked={deductionSettings?.enabled}
                        />
                        <label className="onoffswitch-label">
                          <span className="onoffswitch-inner"></span>
                          <span className="onoffswitch-switch"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label>Calculate By</label>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={paymentType}
                        onChange={(e) => setPaymentType(e.target.value)}
                      >
                        {payTypes.map((a, i) => (
                          <option key={i} value={a.value}>
                            {a.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    {paymentType === "Percentage" ? (
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Percentage</label>
                          <input
                            className="form-control"
                            type="text"
                            value={deductionSettings?.percentage}
                            name="percentage"
                            onChange={(e) =>
                              setDeductionSettings({
                                ...deductionSettings,
                                percentage: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    ) : paymentType === "Static" ? (
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Fixed </label>

                          <CurrencyInput
                            className="form-control"
                            value={deductionSettings?.percentage}
                            allowNegativeValue={false}
                            // allowDecimals={false}
                            onValueChange={(value, name) =>
                              setDeductionSettings({
                                ...deductionSettings,
                                percentage: value,
                              })
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div className="row my-3">
                    <div className="col-6">
                      <label>Apply to: </label>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={applySelected}
                        onChange={(e) => {
                          setApplySelected(e.target.value);
                        }}
                      >
                        {applyTo.map((a, i) => (
                          <option key={i} value={a.value}>
                            {a.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {applySelected !== "Range" ? (
                      <>
                        {gradeEmployees?.length > 0 && (
                          <div className="col-6">
                            <label>Select:</label>
                            <SelectComponent
                              isFetching={isFetching}
                              mainItems={gradeEmployees}
                              selectedItems={selectedGradeEmployees}
                              setSelectedItems={setSelectedGradeEmployees}
                              defaultSelected={defaultSelected}
                            />
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Min Salary:</label>
                            <CurrencyInput
                              className="form-control"
                              value={salaryRange.minRange}
                              allowNegativeValue={false}
                              // allowDecimals={false}
                              onValueChange={(value, name) =>
                                setSalaryRange({
                                  ...salaryRange,
                                  minRange: value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Max Salary:</label>
                            <CurrencyInput
                              className="form-control"
                              min={salaryRange.minRange}
                              value={salaryRange.maxRange}
                              allowNegativeValue={false}
                              // allowDecimals={false}
                              onValueChange={(value, name) =>
                                setSalaryRange({
                                  ...salaryRange,
                                  maxRange: value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Maturity Period */}
                  <div className="row my-3">
                    <div className="col-md-6">
                      <label>Maturity Period (from joined date):</label>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={paymentPeriod}
                        onChange={(e) => setPaymentPeriod(e.target.value)}
                      >
                        {maturityPeriod.map((a, i) => (
                          <option key={i} value={a.value}>
                            {a.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {paymentPeriod === "CustomPeriod" && (
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Period:</label>
                            <input
                              type="number"
                              placeholder="Number of months/years"
                              value={numberYearMonth}
                              className="form-control"
                              onChange={(e) =>
                                setNumberYearMonth(e.target.value)
                              }
                              required={
                                paymentPeriod === "CustomPeriod" ? true : false
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Month/Year:</label>
                            <select
                              className="form-control"
                              aria-label="Default select example"
                              value={yearMonth}
                              onChange={(e) => setYearMonth(e.target.value)}
                              required={
                                paymentPeriod === "CustomPeriod" ? true : false
                              }
                            >
                              {maturityTime.map((a, i) => (
                                <option key={i} value={a.value}>
                                  {a.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/*Duration Time  */}

                  <div className="row my-3">
                    <div className="col-md-6">
                      <label>Duration:</label>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        value={durationType}
                        onChange={(e) => setDurationType(e.target.value)}
                      >
                        {duration.map((a, i) => (
                          <option key={i} value={a.value}>
                            {a.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {durationType === "CustomDuration" && (
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Start Date</label>
                            <SingleDatePicker
                              value={dateRange.startDate}
                              filterByDateRange={filterByDateRange}
                              name="startDate"
                              dateFormat="MM/YYYY"
                            />
                          </div>

                          <div className="col-md-6">
                            <label>End Date</label>
                            <SingleDatePicker
                              value={dateRange.endDate}
                              filterByDateRange={filterByDateRange}
                              name="endDate"
                              dateFormat="MM/YYYY"
                              isValidDate={validationEndDate}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Percentage of salary */}
                {paymentType === "Percentage" && (
                  <>
                    <hr />
                    <p>{deductionSettings?.percentage}% of </p>
                    <div className="row">
                      {deductionSettings?.basic || showDeduct?.basic ? (
                        <DisplayPercentageInput
                          name="basic"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {deductionSettings?.housing || showDeduct?.housing ? (
                        <DisplayPercentageInput
                          name="housing"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {deductionSettings?.medical || showDeduct?.medical ? (
                        <DisplayPercentageInput
                          name="medical"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {deductionSettings?.transport || showDeduct?.transport ? (
                        <DisplayPercentageInput
                          name="transport"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {deductionSettings?.utility || showDeduct?.utility ? (
                        <DisplayPercentageInput
                          name="utility"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {deductionSettings?.entertainment ||
                      showDeduct?.entertainment ? (
                        <DisplayPercentageInput
                          name="entertainment"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {deductionSettings?.dressing || showDeduct?.dressing ? (
                        <DisplayPercentageInput
                          name="dressing"
                          settings={deductionSettings}
                        />
                      ) : null}

                      {customSettings?.map((el) => (
                        <div className="col-md-4">
                          <div
                            className="form-check d-block"
                            style={{
                              height: "44px",
                              padding: "6px 0",
                              display: "inline-block",
                            }}
                          >
                            <input
                              style={{ height: "30px", width: "30px" }}
                              type="checkbox"
                              checked={el?.status}
                              onChange={() => changeCustom(el?.name)}
                            />
                            <label
                              style={{
                                margin: "10px",
                                verticalAlign: "bottom",
                              }}
                            >
                              {el?.name}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                    {getAllSets.length > 0 && (
                      <div className="col-8 my-4">
                        <label>Add More:</label>
                        <Select
                          closeMenuOnSelect={true}
                          isLoading={isFetching}
                          isMulti
                          isSearchable={true}
                          defaultValue={
                            settingsDefault.length
                              ? getAllSets.filter((d) =>
                                  settingsDefault.find(
                                    (e) => e.name === d.label
                                  )
                                )
                              : []
                          }
                          onChange={(selected) => {
                            setSelectSettings(selected);
                          }}
                          options={getAllSets}
                        />
                      </div>
                    )}
                  </>
                )}

                <div className="row">
                  <div className="col-md-2">
                    <button type="submit" className="btn btn-primary mt-3">
                      {btnText}
                    </button>
                  </div>

                  <div
                    className="col-md-2"
                    style={
                      [
                        "add new",
                        "pension",
                        "paye tax",
                        "nsitf",
                        "company pension",
                      ].includes(settingsName)
                        ? { display: "none" }
                        : {}
                    }
                  >
                    <button
                      type="button"
                      className="btn btn-danger mt-3"
                      onClick={toggleModal}
                    >
                      {deleteBtnText}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {/*<!-- /Content End -->*/}
          </div>
          {/*<!-- /Page Content -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}

        {/*<!-- Delete Setting Modal -->*/}
        <div
          className="modal custom-modal fade"
          id="delete_employee"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-header">
                  <h3 className="text-capitalize">
                    Delete {deductionSettings?.name}
                  </h3>
                  <p>Are you sure want to delete this setting?</p>
                </div>
                <div className="modal-btn delete-action">
                  <div className="row">
                    <div className="col-6">
                      <button
                        className="btn btn-primary continue-btn"
                        onClick={() => deleteSetting(deductionSettings?.slug)}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        data-dismiss="modal"
                        className="btn btn-primary cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*<!-- /Delete Setting Modal -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <ModalLoader show={isFetching} />
      <div className="sidebar-overlay" data-reff=""></div>
    </body>
  );
}

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteDeduction: (slug) => dispatch(deleteDeduction(slug)),
    addDeduction: (deduction) => dispatch(addDeduction(deduction)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DeductionSettings));
